// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IScheduledContributionResponseDto
 */
export interface IScheduledContributionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IScheduledContributionResponseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IScheduledContributionResponseDto
     */
    calendar_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IScheduledContributionResponseDto
     */
    tax_type?: IScheduledContributionResponseDtoTaxTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IScheduledContributionResponseDto
     */
    status?: IScheduledContributionResponseDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IScheduledContributionResponseDto
     */
    start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IScheduledContributionResponseDto
     */
    deletion_date?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IScheduledContributionResponseDtoTaxTypeEnum {
    PRE_TAX = 'PRE_TAX',
    POST_TAX = 'POST_TAX'
}
/**
* @export
* @enum {string}
*/
export enum IScheduledContributionResponseDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    DEACTIVATED = 'DEACTIVATED',
    REMOVED = 'REMOVED'
}


/**
 * Check if a given object implements the IScheduledContributionResponseDto interface.
 */
export function instanceOfIScheduledContributionResponseDto(value: object): value is IScheduledContributionResponseDto {
    return true;
}

export function IScheduledContributionResponseDtoFromJSON(json: any): IScheduledContributionResponseDto {
    return IScheduledContributionResponseDtoFromJSONTyped(json, false);
}

export function IScheduledContributionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IScheduledContributionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'calendar_id': json['calendar_id'] == null ? undefined : json['calendar_id'],
        'tax_type': json['tax_type'] == null ? undefined : json['tax_type'],
        'status': json['status'] == null ? undefined : json['status'],
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'deletion_date': json['deletion_date'] == null ? undefined : (new Date(json['deletion_date'])),
    };
}

export function IScheduledContributionResponseDtoToJSON(json: any): IScheduledContributionResponseDto {
    return IScheduledContributionResponseDtoToJSONTyped(json, false);
}

export function IScheduledContributionResponseDtoToJSONTyped(value?: IScheduledContributionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'calendar_id': value['calendar_id'],
        'tax_type': value['tax_type'],
        'status': value['status'],
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString().substring(0,10)),
        'deletion_date': value['deletion_date'] == null ? undefined : ((value['deletion_date']).toISOString().substring(0,10)),
    };
}

